import type {Thread} from '@github-ui/diff-lines/conversation-types'

export function isThreadOutdated(thread: Thread): boolean {
  return thread.isOutdated || thread.subject?.isOutdated || thread.positioning?.isOutdated || false
}

// When a thread is outdated, link to the original diff view instead of the inline comment anchor.
export function getThreadCommentHref(thread: Thread, commentId: number | null | undefined): string {
  return isThreadOutdated(thread) && thread.originalDiffPathUri ? thread.originalDiffPathUri : `#r${commentId}`
}
